export const CACHE_KEY = {
    USERS_CACHE_DATE: 'usersCacheDate',
    USERS: 'users',
}